import { createSelector } from 'reselect';

export const templateSelector = createSelector(
	state => state.template,
	(templates) => {
		var recent_modified = 0;
		var recent_template;
		for (var i in templates){
			if (templates[i].value.modified > recent_modified){
				recent_template = templates[i];
				recent_modified = templates[i].value.modified;
			}
		}
		return recent_template.value;
	}
);


// WEBPACK FOOTER //
// ./src/client/selectors/templateSelector.js